/**
 * Created by zzy on 2019/8/5.
 */
import InfraredThermography from './InfraredThermography.vue'
export default InfraredThermography



// WEBPACK FOOTER //
// ./src/views/monitoring/infraredThermography/index.js